import { gql } from "graphql-tag";

export const documentsQuery = gql`
  query UserDocuments {
    viewer {
      id
      documents {
        id
        category
        name
        uploadedAt
        url
        downloadUrl
      }
    }
  }
`;
